import React, { useContext } from 'react';
import VoiceFillIcon from 'components/lib/icons/voice_fill_icon';
import FloorboardRow from './floorboard_row';
import LiveboardContext from 'components/liveboards/contexts/liveboard_context.jsx';

export default function VoiceRow() {
  const { channel, sla } = useContext(LiveboardContext);

  const stats = channel.phone;
  const callSla = sla.phone;
  return (
    <FloorboardRow
      newItems={stats.currentNewCalls}
      activeItems={stats.currentActiveCalls}
      currentWait={stats.currentWait}
      sla={callSla}
      activeLabel="Active Calls"
      newLabel="New Calls"
      waitLabel="Current Wait"
      icon={<VoiceFillIcon />}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/floorboard/voice_row.jsx